/**
 * 소모품 메모 API 클라이언트.
 *
 * 회사 전체 메모(site_project_id = 0)와 현장별 메모가 같은 모양이다 — 자유 서식
 * 마크다운 한 장. 백엔드 /v0.1/site-management/consumable-notes[...] 와 1:1.
 */
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import { ApiItemResponse, ApiListResponse, unwrapItem, unwrapList } from './api/response';

export interface SiteConsumableNote {
  /** 저장된 적이 없으면 0 — 화면은 그래도 빈 메모 한 장으로 다룬다. */
  id: number;
  /** 0 = 회사 전체, 그 외 = 현장 프로젝트 ID. */
  site_project_id: number;
  /** 마크다운 본문. */
  content: string;
  updated_by_id?: number;
  updated_by_name?: string;
  created_at?: string;
  updated_at?: string;
}

/** 회사 전체 메모를 가리키는 프로젝트 ID. */
export const COMPANY_NOTE_ID = 0;

function endpoint(projectId: number): string {
  return projectId === COMPANY_NOTE_ID
    ? API_ENDPOINTS.SITE_MANAGEMENT.CONSUMABLE_NOTES.COMPANY
    : API_ENDPOINTS.SITE_MANAGEMENT.CONSUMABLE_NOTES.PROJECT(projectId);
}

export class SiteConsumableNoteService {
  /** 회사 전체 + 현장별 메모 전부. 저장된 행만 온다. */
  static async listAll(): Promise<SiteConsumableNote[]> {
    const resp = await apiClient.get<ApiListResponse<SiteConsumableNote>>(
      API_ENDPOINTS.SITE_MANAGEMENT.CONSUMABLE_NOTES.LIST,
    );
    return unwrapList(resp, '소모품 메모 목록 조회 실패');
  }

  /** projectId 0 이면 회사 전체. 없으면 빈 메모가 온다(404 아님). */
  static async get(projectId: number): Promise<SiteConsumableNote> {
    const resp = await apiClient.get<ApiItemResponse<SiteConsumableNote>>(endpoint(projectId));
    return unwrapItem(resp, '소모품 메모 조회 실패');
  }

  static async save(projectId: number, content: string): Promise<SiteConsumableNote> {
    const resp = await apiClient.put<ApiItemResponse<SiteConsumableNote>>(endpoint(projectId), { content });
    return unwrapItem(resp, '소모품 메모 저장 실패');
  }
}
